const OUTSIDE_PREFIX = 'FUNDING_PROGRAM_OUTSIDE_AGED_CARE_ACT:';

const OUTSIDE_REGIME_LABELS: Record<string, string> = {
  NDIS: 'NDIS',
  TAC: 'Transport Accident Commission',
  PRIVATE: 'private funding',
};

const BASIS_LABELS: Record<string, string> = {
  FUNDING_PROGRAM_IN_SCOPE: 'Aged Care Act programme funding',
  LINKED_SERVICE_DELIVERED: 'Linked to a delivered aged care service',
  LINKED_CARE_PLAN_SERVICE_INCLUSION: 'Linked to a care plan service',
  LINKED_RESIDENTIAL_ROUND: 'Linked to a residential care round',
  LINKED_ADL_CARE_EVENT: 'Linked to a residential care event',
  LINKED_RESIDENTIAL_SHIFT: 'Linked to a residential shift',
  LINKED_ROSTER_SHIFT: 'Linked to a rostered shift',
  RESIDENTIAL_FACILITY_CONTEXT: 'Occurred in a residential care home',
  RESIDENTIAL_CLIENT_PROGRAM_CONTEXT: 'Resident receiving residential care',
  FUNDING_ALLOCATION_MIXED_AGED_CARE_AND_OTHER: 'Mixed funding requires compliance review',
  FUNDING_PROGRAM_UNRECOGNISED: 'Funding programme requires compliance review',
  DVA_SCOPE_REQUIRES_COMPLIANCE_REVIEW: 'DVA funding requires compliance review',
  FUNDING_PROGRAM_OUT_OF_SCOPE: 'Outside the Aged Care Act',
  MANUAL_COMPLIANCE_DECISION: 'Decided by the provider',
  NO_SOURCE_CONTEXT: 'No service funding context is available',
};

const REVIEW_FALLBACK = 'Funding scope requires review';

/**
 * Converts a persisted SIRS funding-scope basis to provider language, so a raw
 * enum token is never displayed. An unrecognised value, or an outside-the-Act
 * basis naming any regime outside NDIS/TAC/private, fails closed to review.
 */
export function formatFundingScopeBasis(value: string | null | undefined): string {
  if (!value) return REVIEW_FALLBACK;
  if (value.startsWith(OUTSIDE_PREFIX)) {
    const regimes = value.slice(OUTSIDE_PREFIX.length).split(',');
    const allKnown =
      regimes.length > 0 && regimes.every((regime) => regime in OUTSIDE_REGIME_LABELS);
    if (!allKnown) return REVIEW_FALLBACK;
    return `Outside the Aged Care Act: check your obligations under ${regimes.map((regime) => OUTSIDE_REGIME_LABELS[regime]).join(', ')}`;
  }
  return BASIS_LABELS[value] ?? REVIEW_FALLBACK;
}
